// https://basescan.org/address/0x529467C76f234F2bD359d7ecF7c660A2846b04e2
export const CROSS_CHAIN_CONTROLLER = '0x529467C76f234F2bD359d7ecF7c660A2846b04e2';

// IPayloadsControllerCore https://basescan.org/address/0x2DC219E716793fb4b21548C0f009Ba3Af753ab01
export const PAYLOADS_CONTROLLER = '0x2DC219E716793fb4b21548C0f009Ba3Af753ab01';

// https://basescan.org/address/0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A
export const PC_DATA_HELPER = '0xE3B770Dc4ae3f8bECaB3Ed12dE692c741603e16A';

// https://basescan.org/address/0xa1c6aF35E0205f42256382C05243C543FEDBf4bB
export const GRANULAR_GUARDIAN = '0xa1c6aF35E0205f42256382C05243C543FEDBf4bB';

// https://basescan.org/address/0x360c0a69Ed2912351227a0b745f890CB2eBDbcFe
export const GOVERNANCE_GUARDIAN = '0x360c0a69Ed2912351227a0b745f890CB2eBDbcFe';

// https://basescan.org/address/0x9390B1735def18560c509E2d0bc090E9d6BA257a
export const EXECUTOR_LVL_1 = '0x9390B1735def18560c509E2d0bc090E9d6BA257a';

export const CHAIN_ID = 8453;
